<template>
  <div :id="info.objectId" style="width: 100%; height: 100%">
  </div>
</template>
<script>
// 全局保存当前选中窗口
var gIWndIndex = 0 // 可以不用设置这个变量，有窗口参数的接口中，不用传值，开发包会默认使用当前选择窗口

// 错误码
// 通用错误
// var ERROR_CODE_UNKNOWN = 1000 // 未知错误
// var ERROR_CODE_NETWORKERROR = 1001 // 网络错误
// var ERROR_CODE_PARAMERROR = 1002 // 缺少插件元素

// 登录模块
// var ERROR_CODE_LOGIN_NOLOGIN = 2000 // 未登录
var ERROR_CODE_LOGIN_REPEATLOGIN = 2001 // 设备已登录，重复登录
// var ERROR_CODE_LOGIN_NOSUPPORT = 2002 // 当前设备不支持Digest登录

// 预览播放
// var ERROR_CODE_PLAY_PLUGININITFAIL = 3000 // 插件初始化失败
// var ERROR_CODE_PLAY_NOREPEATPLAY = 3001 // 当前窗口已经在预览
// var ERROR_CODE_PLAY_PLAYBACKABNORMAL = 3002 // 回放异常
// var ERROR_CODE_PLAY_PLAYBACKSTOP = 3003 // 回放停止
// var ERROR_CODE_PLAY_NOFREESPACE = 3004 // 录像过程中，硬盘容量不足

// 对讲
// var ERROR_CODE_TALK_FAIL = 5000 // 语音对讲失败
const WebVideoCtrl = window.WebVideoCtrl
const $ = window.$
export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      szDeviceIdentify: undefined,
      deviceport: undefined,
      rtspport: undefined,
      iChannelID: undefined,
      bZeroChannel: false,
      g_bPTZAuto: false,
      logs: []
    }
  },
  computed: {
    canView () {
      const deviceport = this.deviceport
      const rtspport = this.rtspport
      const iChannelID = this.iChannelID
      const bZeroChannel = this.deviceport
      return deviceport && rtspport && iChannelID && bZeroChannel
    }
  },
  watch: {
    logs (newV) {
      console.log(newV[newV.length - 1])
    },
    canView (newV, oldV) {
      if (newV) {
        setTimeout(this.clickStartRealPlay, 500)
      }
    }
  },
  methods: {
    move (dir) {
      if (!this.canView) return
      let target = 1
      switch (dir) {
        case 'left':
          target = 3
          break
        case 'top':
          target = 1
          break
        case 'right':
          target = 4
          break
        case 'bottom':
          target = 2
          break
      }
      this.mouseDownPTZControl(target)
    },
    stopMove () {
      if (!this.canView) return
      this.mouseUpPTZControl()
    },
    zoomIn () {
      if (!this.canView) return
      this.PTZZoomIn()
    },
    zoomOut () {
      if (!this.canView) return
      this.PTZZoomout()
    },
    stopZoom () {
      if (!this.canView) return
      this.PTZZoomStop()
    },
    // 初始化插件
    init () {
      const that = this
      // 初始化插件参数及插入插件
      WebVideoCtrl.I_InitPlugin({
        bWndFull: true, // 是否支持单窗口双击全屏，默认支持 true:支持 false:不支持
        iWndowType: 1,
        cbSelWnd: function (xmlDoc) {
          // g_iWndIndex = parseInt($(xmlDoc).find('SelectWnd').eq(0).text(), 10)
          // var szInfo = '当前选择的窗口编号：' + g_iWndIndex
          // showCBInfo(szInfo)
        },
        cbDoubleClickWnd: function (iWndIndex, bFullScreen) {
          // var szInfo = '当前放大的窗口编号：' + iWndIndex
          // if (!bFullScreen) {
          //   szInfo = '当前还原的窗口编号：' + iWndIndex
          // }
          // showCBInfo(szInfo)
        },
        cbEvent: function (iEventType, iParam1, iParam2) {
          // if (iEventType == 2) { // 回放正常结束
          //   showCBInfo('窗口' + iParam1 + '回放结束！')
          // } else if (iEventType == -1) {
          //   showCBInfo('设备' + iParam1 + '网络错误！')
          // } else if (iEventType == 3001) {
          //   clickStopRecord(g_szRecordType, iParam1)
          // }
        },
        cbInitPluginComplete: function () {
          WebVideoCtrl.I_InsertOBJECTPlugin(that.info.objectId).then(() => {
            that.logs.push('初始化成功')
            // 检查插件是否最新
            WebVideoCtrl.I_CheckPluginVersion().then((bFlag) => {
              if (bFlag) {
                // alert('检测到新的插件版本，双击开发包目录里的HCWebSDKPlugin.exe升级！')
              }
              setTimeout(that.login(), 50)
            })
          }, () => {
            that.$notification['error']({
              message: '操作失败',
              duration: null,
              description (h) {
                return h('p', [
                  h('span', '初始化插件失败，请下载安装'),
                  h('a', {
                    attrs: {
                      href: 'https://nextcloud.mokecloud.com:7733/s/nK6HM8wnrNnpdHf/download/HCWebSDKPlugin.exe'
                    },
                    style: {
                      color: '#1890ff',
                      wordBreak: 'break-all'
                    }
                  }, '插件(https://nextcloud.mokecloud.com:7733/s/nK6HM8wnrNnpdHf/download/HCWebSDKPlugin.exe)'),
                  h('span', '后重试')
                ])
              }
            })
            that.destroyPlugin()
          })
        }
      })
    },
    // 登录设备
    login () {
      const that = this
      const IP = this.info.IP
      const port = 80
      const account = this.info.accountName
      const passward = this.info.password
      this.szDeviceIdentify = IP + '_' + port
      WebVideoCtrl.I_Login(IP, 1, port, account, passward, {
        timeout: 3000,
        success: function (xmlDoc) {
          that.logs.push('登录成功！')
          setTimeout(function () {
            that.getDevicePort()
            setTimeout(function () {
              that.getChannelInfo()
            }, 1000)
          }, 10)
        },
        error: function (oError) {
          if (ERROR_CODE_LOGIN_REPEATLOGIN === oError) {
            that.logs.push('已登录过！')
          } else {
            that.logs.push('登录失败！')
            that.$notification['error']({
              message: '操作失败',
              description: '连接摄像头失败，请检查摄像头状态'
            })
            that.destroyPlugin()
          }
        }
      })
    },
    // 获取端口信息
    getDevicePort () {
      if (!this.szDeviceIdentify) {
        return
      }
      WebVideoCtrl.I_GetDevicePort(this.szDeviceIdentify).then((oPort) => {
        this.deviceport = oPort.iDevicePort
        this.rtspport = oPort.iRtspPort
        this.logs.push('获取端口成功！')
      }, (oError) => {
        this.logs.push('获取端口成功！')
      })
    },
    // 获取通道信息
    getChannelInfo () {
      const that = this
      const szDeviceIdentify = this.szDeviceIdentify
      // var oSel = $('#channels').empty()

      if (szDeviceIdentify == null) {
        return
      }

      // 模拟通道
      WebVideoCtrl.I_GetAnalogChannelInfo(szDeviceIdentify, {
        success: function (xmlDoc) {
          var oChannels = $(xmlDoc).find('VideoInputChannel')

          $.each(oChannels, function (i) {
            var id = $(this).find('id').eq(0).text()
            var name = $(this).find('name').eq(0).text()
            if (name === '') {
              name = 'Camera ' + (i < 9 ? '0' + (i + 1) : (i + 1))
            }
            that.iChannelID = id
            that.bZeroChannel = false
            // oSel.append("<option value='" + id + "' bZero='false'>" + name + '</option>')
          })
          that.logs.push('获取模拟通道成功！')
        },
        error: function (oError) {
          that.logs.push(szDeviceIdentify + ' 获取模拟通道失败！', oError.errorCode, oError.errorMsg)
        }
      })
      // 数字通道
      WebVideoCtrl.I_GetDigitalChannelInfo(szDeviceIdentify, {
        success: function (xmlDoc) {
          var oChannels = $(xmlDoc).find('InputProxyChannelStatus')

          $.each(oChannels, function (i) {
            var id = $(this).find('id').eq(0).text()
            var name = $(this).find('name').eq(0).text()
            var online = $(this).find('online').eq(0).text()
            if (online === 'false') { // 过滤禁用的数字通道
              return true
            }
            if (name === '') {
              name = 'IPCamera ' + (i < 9 ? '0' + (i + 1) : (i + 1))
            }
            that.iChannelID = id
            that.bZeroChannel = false

            // oSel.append("<option value='" + id + "' bZero='false'>" + name + '</option>')
          })
          that.logs.push(szDeviceIdentify + ' 获取数字通道成功！')
        },
        error: function (oError) {
          that.logs.push(szDeviceIdentify + ' 获取数字通道失败！', oError.errorCode, oError.errorMsg)
        }
      })
      // 零通道
      WebVideoCtrl.I_GetZeroChannelInfo(szDeviceIdentify, {
        success: function (xmlDoc) {
          var oChannels = $(xmlDoc).find('ZeroVideoChannel')

          $.each(oChannels, function (i) {
            var id = $(this).find('id').eq(0).text()
            var name = $(this).find('name').eq(0).text()
            if (name === '') {
              name = 'Zero Channel ' + (i < 9 ? '0' + (i + 1) : (i + 1))
            }
            if ($(this).find('enabled').eq(0).text() === 'true') { // 过滤禁用的零通道
              // oSel.append("<option value='" + id + "' bZero='true'>" + name + '</option>')
              that.iChannelID = id
              that.bZeroChannel = true
            }
          })
          that.logs.push(szDeviceIdentify + ' 获取零通道成功！')
        },
        error: function (oError) {
          that.logs.push(szDeviceIdentify + ' 获取零通道失败！', oError.errorCode, oError.errorMsg)
        }
      })
    },
    // 开始预览
    clickStartRealPlay () {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      var szDeviceIdentify = this.szDeviceIdentify
      // var iRtspPort = parseInt(this.iRtspPort, 10)
      var iChannelID = parseInt(this.iChannelID, 10)
      var bZeroChannel = this.bZeroChannel
      var szInfo = ''
      var iStreamType = 1

      if (szDeviceIdentify == null) {
        return
      }
      const that = this
      var startRealPlay = function () {
        console.log('开始预览')
        console.log(szDeviceIdentify, iStreamType, iChannelID, bZeroChannel)
        WebVideoCtrl.I_StartRealPlay(szDeviceIdentify, {
          iStreamType: iStreamType,
          iChannelID: iChannelID,
          bZeroChannel: bZeroChannel,
          success: function () {
            console.log('开始预览成功！')
            szInfo = '开始预览成功！'
            that.logs.push(szDeviceIdentify + ' ' + szInfo)
          },
          error: function (oError) {
            console.log('开始预览失败！')
            that.logs.push(szDeviceIdentify + ' 开始预览失败！', oError.errorCode, oError.errorMsg)
          }
        })
      }

      if (oWndInfo != null) { // 已经在播放了，先停止
        WebVideoCtrl.I_Stop({
          success: function () {
            startRealPlay()
          }
        })
      } else {
        startRealPlay()
      }
    },
    // 停止预览
    clickStopRealPlay () {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      var szInfo = ''
      const that = this
      if (oWndInfo != null) {
        WebVideoCtrl.I_Stop({
          success: function () {
            szInfo = '停止预览成功！'
            that.logs.push(oWndInfo.szDeviceIdentify + ' ' + szInfo)
            that.clickLogout()
          },
          error: function (oError) {
            that.logs.push(' 停止预览失败！', oError.errorCode, oError.errorMsg)
            that.clickLogout()
          }
        })
      }
    },
    // 退出
    clickLogout () {
      var szDeviceIdentify = this.szDeviceIdentify

      if (szDeviceIdentify == null) {
        this.destroyPlugin()
        return
      }

      WebVideoCtrl.I_Logout(szDeviceIdentify).then(() => {
        this.logs.push(szDeviceIdentify + ' ' + '退出成功！')
        this.destroyPlugin()
      }, () => {
        this.logs.push(szDeviceIdentify + ' ' + '退出失败！')
        this.destroyPlugin()
      })
    },
    // 销毁插件
    destroyPlugin () {
      WebVideoCtrl.I_DestroyPlugin().then(() => {
        this.logs.push('销毁插件成功！')
      }, () => {
        this.logs.push('销毁插件失败！')
      })
    },
    // PTZ控制 9为自动，1,2,3,4,5,6,7,8为方向PTZ（移动）
    mouseDownPTZControl (iPTZIndex) {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      var bZeroChannel = this.bZeroChannel
      var iPTZSpeed = 4
      const that = this
      if (bZeroChannel) { // 零通道不支持云台
        return
      }

      if (oWndInfo != null) {
        if (iPTZIndex === 9 && this.g_bPTZAuto) {
          iPTZSpeed = 0// 自动开启后，速度置为0可以关闭自动
        } else {
          this.g_bPTZAuto = false// 点击其他方向，自动肯定会被关闭
        }

        WebVideoCtrl.I_PTZControl(iPTZIndex, false, {
          iPTZSpeed: iPTZSpeed,
          success: function (xmlDoc) {
            if (iPTZIndex === 9 && this.g_bPTZAuto) {
              that.log.push(oWndInfo.szDeviceIdentify + ' 停止云台成功！')
            } else {
              that.log.push(oWndInfo.szDeviceIdentify + ' 开启云台成功！')
            }
            if (iPTZIndex === 9) {
              that.g_bPTZAuto = !that.g_bPTZAuto
            }
          },
          error: function (oError) {
            that.log.push(oWndInfo.szDeviceIdentify + ' 开启云台失败！', oError.errorCode, oError.errorMsg)
          }
        })
      }
    },
    // 方向PTZ停止
    mouseUpPTZControl () {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      const that = this
      if (oWndInfo != null) {
        WebVideoCtrl.I_PTZControl(1, true, {
          success: function (xmlDoc) {
            that.logs.push(oWndInfo.szDeviceIdentify + ' 停止云台成功！')
          },
          error: function (oError) {
            that.logs.push(oWndInfo.szDeviceIdentify + ' 停止云台失败！', oError.errorCode, oError.errorMsg)
          }
        })
      }
    },
    // 放大
    PTZZoomIn () {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      const that = this
      if (oWndInfo != null) {
        WebVideoCtrl.I_PTZControl(10, false, {
          iWndIndex: gIWndIndex,
          success: function (xmlDoc) {
            that.logs.push(oWndInfo.szDeviceIdentify + ' 调焦+成功！')
          },
          error: function (oError) {
            that.logs.push(oWndInfo.szDeviceIdentify + '  调焦+失败！', oError.errorCode, oError.errorMsg)
          }
        })
      }
    },
    // 缩小
    PTZZoomout () {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      const that = this
      if (oWndInfo != null) {
        WebVideoCtrl.I_PTZControl(11, false, {
          iWndIndex: gIWndIndex,
          success: function (xmlDoc) {
            that.logs.push(oWndInfo.szDeviceIdentify + ' 调焦-成功！')
          },
          error: function (oError) {
            that.logs.push(oWndInfo.szDeviceIdentify + '  调焦-失败！', oError.errorCode, oError.errorMsg)
          }
        })
      }
    },
    // 停止调焦
    PTZZoomStop () {
      var oWndInfo = WebVideoCtrl.I_GetWindowStatus(gIWndIndex)
      const that = this
      if (oWndInfo != null) {
        WebVideoCtrl.I_PTZControl(11, true, {
          iWndIndex: gIWndIndex,
          success: function (xmlDoc) {
            that.logs.push(oWndInfo.szDeviceIdentify + ' 调焦停止成功！')
          },
          error: function (oError) {
            that.logs.push(oWndInfo.szDeviceIdentify + '  调焦停止失败！', oError.errorCode, oError.errorMsg)
          }
        })
      }
    },
    logOut () {
      this.clickLogout()
    }

  },
  mounted () {
    setTimeout(this.init, 700)
  },
  beforeDestroy () {
    this.logOut()
  }
}
</script>
<style></style>
